import { CardComponentProps } from "@~/types/types";
import styles from "./StockMessage.module.scss";
import { isOutOfStock, isRetiredProduct } from "@~/utils/product";

export function StockMessage({ product }: Pick<CardComponentProps, "product">) {
  let message = "Currently in stock online";

  if (isRetiredProduct(product)) {
    message =
      "We no longer stock this item, but we may have similar products available";
  }

  if (isOutOfStock(product)) {
    message = "Out of stock online";
  }

  return (
    <p data-component="StockMessage" className={styles.message}>
      {message}
    </p>
  );
}
